import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ef5e4a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "p-7 flex-grow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5 text-xl" }, "Gallery Images", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "py-3 text-gray-text" }, "The image you upload here will be in your image gallery.", -1))
const _hoisted_5 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-44 my-2 md:my-0" }, "Upload Gallery Image", -1))
const _hoisted_7 = {
  key: 0,
  class: "row card-header-tabs border-theme border-dotted p-1 mb-3 pt-2"
}
const _hoisted_8 = { class: "bg-card img-container pb-1" }
const _hoisted_9 = { class: "image-section" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  for: "btnFileUpload",
  class: "rounded-md bg-black-primary px-4 p-2 cursor-pointer text-white mr-2"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Choose File")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pt-2 text-gray-text" }, [
  /*#__PURE__*/_createTextVNode(" Maximum of nine (9) images only "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Maximum of 5KB file size per image"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" JPG and PNG image formats only ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-10 py-2 px-2 rounded-md bg-black-sidebar text-gray-text font-bold w-max text-xs" }, "*Please Note that gallery images changes will apply after the changes has been published and approved.", -1))
const _hoisted_15 = { class: "py-5 p-7 bg-black-sidebar" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GamesGalleryComponent = _resolveComponent("GamesGalleryComponent")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.gallery)
        ? (_openBlock(), _createBlock(_component_GamesGalleryComponent, { key: _ctx.galleryKey }))
        : _createCommentVNode("", true),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", null, [
          (this.file)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.file, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "my-2 text-white col-md-2",
                    key: item.name
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          src: _ctx.preview[index],
                          alt: "",
                          width: "150",
                          length: "150"
                        }, null, 8, _hoisted_10),
                        _createVNode(_component_font_awesome_icon, {
                          icon: "fa-solid fa-times-circle",
                          class: "text-gray-text inline-block",
                          onClick: ($event: any) => (_ctx.removeFile(item.name))
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("p", null, _toDisplayString(item.name), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_11, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-paperclip",
                class: "inline-block text-blue-primary mr-2"
              }),
              _hoisted_12
            ]),
            _createElementVNode("input", {
              type: "file",
              multiple: "",
              accept: "image/*",
              id: "btnFileUpload",
              style: {"display":"none"},
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFileUpload($event)))
            }, null, 32),
            _createElementVNode("button", {
              class: "rounded-md bg-black-primary px-4 p-2 cursor-pointer text-white",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeAllFiles()))
            }, "Clear File"),
            _hoisted_13
          ])
        ])
      ]),
      _hoisted_14
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary px-5",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addImageGallery && _ctx.addImageGallery(...args))),
        disabled: _ctx.isDisabledSaveButton
      }, _toDisplayString(_ctx.isUploading?'Adding image':'Save'), 9, _hoisted_16)
    ])
  ]))
}